import { useTheme } from 'styled-components'

import { IconBase, IconProps } from './Base'

export const IconCopy = (props: IconProps) => {
  const theme = useTheme()
  return (
    <IconBase width={props.width || 16} height={props.height || 17} viewBox="0 0 16 17" fill="none">
      <g clipPath="url(#clip0_3007_3287)">
        <path
          d="M13.3333 5.83325H6.66665C5.93027 5.83325 5.33331 6.43021 5.33331 7.16659V13.8333C5.33331 14.5696 5.93027 15.1666 6.66665 15.1666H13.3333C14.0697 15.1666 14.6666 14.5696 14.6666 13.8333V7.16659C14.6666 6.43021 14.0697 5.83325 13.3333 5.83325Z"
          stroke={theme.colors.text.primary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.66665 11.1666C1.93331 11.1666 1.33331 10.5666 1.33331 9.83325V3.16659C1.33331 2.43325 1.93331 1.83325 2.66665 1.83325H9.33331C10.0666 1.83325 10.6666 2.43325 10.6666 3.16659"
          stroke={theme.colors.text.primary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3007_3287">
          <rect width="16" height="16" fill={theme.colors.background.primary} transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </IconBase>
  )
}
